const CoreAccessIcon = ({ variant = 'breach' }) => (
  <svg
    className="coreAccessIcon"
    viewBox="0 0 48 48"
    aria-hidden="true"
    focusable="false"
  >
    <path
      className="coreAccessIconOrbit"
      d="M8 24 8 15 21 6M28 5 41 13 43 25M38 35 27 43 15 40M8 33 5 29"
    />
    {variant === 'exchange' ? (
      <>
        <path d="m12 35 23-23M23 12h12v12" />
        <path className="coreAccessIconGlint" d="M13 25v10h10M18 40h10l9-9" />
      </>
    ) : (
      <>
        <path
          className="coreAccessIconSpear"
          d="m9 39 15-20-2-7 17-3-3 17-7-2Z"
        />
        <path className="coreAccessIconGlint" d="m15 33 18-18M27 15l7-1-1 7" />
      </>
    )}
  </svg>
);

export default CoreAccessIcon;
